export default {
  resource: {
    zh: {
      title:"系统参数",
      codeKey: "键",
      codeValue: "值",
      codeDesc:	"备注",
      param0:	"参数0",
      param1:	"参数1",
      param2:	"参数2",
      param3:	"参数3",
      param4:	"参数4",
      param5:	"参数5",
      nullKey:"键不能为空不能为空！",
      nullValue:"值不能为空不能为空！",
      alExists:"键值已经存在，请检查！"
    }

  },
  delConf:["codeKey", "codeValue"],
  delKeys:["autoid"],
  params: {
    codeKey:{
      key: "codeKey",
      data: null,
      method: "Contains",
      type: "text"
    },
    codeValue:{
      key: "codeValue",
      data: null,
      method: "Contains",
      type: "text"
    }
  },
  listDefine: [
    "codeKey","codeValue","param0","param1","param2","param3","param4","param5","codeDesc"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName: "codeKey",
  defaultSortOrder: "asc",
  sortName: "codeKey",
  sortOrder: "asc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  autoId:"autoid",
  url:"sysCode/"

}
